"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var api_1 = __importDefault(require("api"));
var use_stores_1 = require("hooks/use-stores");
var use_notification_1 = require("hooks/use-notification");
var Notification_1 = require("components/core/Notification");
var QueriesStore_1 = require("stores/QueriesStore");
var Select_1 = __importDefault(require("components/core/inputs/Select"));
var Radios_1 = __importDefault(require("components/core/inputs/Radios"));
var Button_1 = __importDefault(require("components/core/buttons/Button"));
var AuthTable_1 = __importDefault(require("./AuthTable"));
var UserStore_1 = require("stores/UserStore");
var InfoRow_1 = __importDefault(require("components/core/common/InfoRow"));
var TextInput_1 = __importDefault(require("components/core/inputs/TextInput"));
var use_dialog_1 = require("../../../../../hooks/use-dialog");
var Dialog_1 = require("../../../../core/Dialog");
var config_1 = __importDefault(require("config"));
var toBoolean = function (input) { return input === "true"; };
var getCurrency = function (country) {
    return country === QueriesStore_1.Countries.IR ? "€" : "£";
};
var PriceQueryStage3 = function (_a) {
    var data = _a.data;
    var _b = use_stores_1.useStores(), queriesStore = _b.queriesStore, userStore = _b.userStore;
    var notification = use_notification_1.useNotification();
    var dialog = use_dialog_1.useDialog();
    var timeoutRef = react_1.useRef(null);
    var history = react_router_dom_1.useHistory();
    var changeHandler = function (e) {
        var _a;
        var value = e.currentTarget.value;
        if (value === "true" || value === "false")
            value = toBoolean(value);
        api_1.default.patchQuery(data.id, (_a = {},
            _a[e.currentTarget.name] = value,
            _a))
            .then(function (response) {
            queriesStore.editDataItem(response.data);
            notification({
                variant: Notification_1.NotificationVariants.SUCCESS,
                message: "Query updated"
            });
        }, function (error) {
            notification({
                variant: Notification_1.NotificationVariants.ERROR,
                message: "Error updating query"
            });
        });
    };
    var approveHandler = function (e) {
        var authLevel = data.priceQuery.approvalLevel;
        var validLevel = userStore.levelPricePermission(authLevel);
        var message = "";
        if (!validLevel) {
            message = "You do not have the correct permissions to approve this query";
        }
        if (!data.priceQuery.queryReason || data.priceQuery.queryReason.length <= 0) {
            message = "Please state a query reason before approving";
        }
        if (data.priceQuery.preventativeAction && !data.priceQuery.preventativeActionComment ||
            data.priceQuery.preventativeAction && data.priceQuery.preventativeActionComment.length <= 0) {
            message = 'Please enter a comment regarding preventative action';
        }
        if (data.priceQuery.backOrder && !data.priceQuery.backOrderComment ||
            data.priceQuery.backOrder && data.priceQuery.backOrderComment.length <= 0) {
            message = 'Please enter a comment regarding back order refresh';
        }
        if (data.priceQuery.correctPricing && !data.priceQuery.correctPricingComment ||
            data.priceQuery.correctPricing && data.priceQuery.correctPricingComment.length <= 0) {
            message = 'Please enter a comment regarding correct pricing';
        }
        if (message.length > 0) {
            notification({
                variant: Notification_1.NotificationVariants.ERROR,
                message: message
            });
            return;
        }
        dialog({
            variant: Dialog_1.DialogVariants.CONFIRMATION,
            title: "Approve this query?",
            description: "Are you sure you want to approve this query? Please write a comment below with your reasoning",
            withComment: true,
            queryId: data.id,
            stage: data.currentStage,
            direction: "Forward"
        })
            .then(function (response) {
            var _a;
            api_1.default.sendQueryForward(data.id, (_a = { currentStage: 3 }, _a["level" + authLevel] = true, _a))
                .then(function (response) {
                queriesStore.editDataItem(response.data);
                notification({
                    variant: Notification_1.NotificationVariants.SUCCESS,
                    message: "Successfully Approved Query"
                });
                history.replace("/");
            });
        });
    };
    var rejectHandler = function (e) {
        var authLevel = data.priceQuery.approvalLevel;
        dialog({
            variant: Dialog_1.DialogVariants.CONFIRMATION,
            title: "Reject this query?",
            description: "Are you sure you want to reject this query? Please write a comment below with your reasoning",
            withComment: true,
            queryId: data.id,
            stage: data.currentStage,
            direction: "Forward"
        })
            .then(function (response) {
            var _a;
            api_1.default.sendQueryForward(data.id, (_a = { currentStage: 3 }, _a["level" + authLevel] = false, _a))
                .then(function (response) {
                queriesStore.editDataItem(response.data);
                notification({
                    variant: Notification_1.NotificationVariants.SUCCESS,
                    message: "Query was rejected"
                });
                history.replace("/");
            });
        });
    };
    var checkAuthExists = function () {
        var authLevel = data.priceQuery.approvalLevel;
        for (var key in data.priceQuery) {
            if (data.priceQuery.hasOwnProperty(key) && key.indexOf("Authorisation") > -1) {
                var level = parseInt(key.match(/\d/g).join(""));
                if (data.priceQuery[key] !== null && level === authLevel)
                    return true;
            }
        }
        return false;
    };
    var getTotals = function () {
        var totals = { dr: 0, cr: 0 };
        for (var _i = 0, _a = data.priceQuery.priceQueryIPCs; _i < _a.length; _i++) {
            var ipcRow = _a[_i];
            totals.dr += ipcRow.newNet * ipcRow.quantity - ipcRow.itemNet * ipcRow.quantity;
            totals.cr += ipcRow.newNet - ipcRow.itemNet;
        }
        return totals;
    };
    var keyHandler = function (e) {
        var name = e.currentTarget.name;
        var value = e.currentTarget.value;
        if (timeoutRef.current !== null)
            clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(function () {
            var _a;
            api_1.default.patchQuery(data.id, (_a = {},
                _a[name] = value,
                _a))
                .then(function (response) {
                queriesStore.editDataItem(response.data);
                notification({
                    variant: Notification_1.NotificationVariants.SUCCESS,
                    message: "Query successfully updated"
                });
            }, function (error) {
                notification({
                    variant: Notification_1.NotificationVariants.ERROR,
                    message: "Error updating query"
                });
            });
        }, 500);
    };
    return (react_1.default.createElement("div", { className: "stage-3-form" },
        react_1.default.createElement("div", { className: "flex flex-row" },
            react_1.default.createElement("div", { className: "half" },
                data.status === QueriesStore_1.QueryStatus.ACTIVE &&
                    userStore.hasPermission(UserStore_1.Permissions.STAGE_3) ?
                    react_1.default.createElement(Select_1.default, { name: "queryReason", value: data.priceQuery.queryReason || "", onChange: changeHandler, options: Object.keys(QueriesStore_1.PriceQueryReasons).filter(function (key) { return isNaN(parseInt(key)); })
                            .map(function (key) { return ({
                            value: QueriesStore_1.PriceQueryReasons[key],
                            text: QueriesStore_1.PriceQueryReasons[key]
                        }); }) })
                    :
                        react_1.default.createElement(InfoRow_1.default, { label: "Query Reason", value: data.priceQuery.queryReason || "None Selected" }),
                data.status === QueriesStore_1.QueryStatus.ACTIVE &&
                    userStore.hasPermission(UserStore_1.Permissions.STAGE_3) ?
                    react_1.default.createElement(Select_1.default, { name: "queryCause", value: data.priceQuery.queryCause || "", onChange: changeHandler, options: Object.keys(QueriesStore_1.PriceQueryCauses).filter(function (key) { return isNaN(parseInt(key)); })
                            .map(function (key) { return ({
                            value: QueriesStore_1.PriceQueryCauses[key],
                            text: QueriesStore_1.PriceQueryCauses[key]
                        }); }) })
                    :
                        react_1.default.createElement(InfoRow_1.default, { label: "Who Caused it?", value: data.priceQuery.queryCause || "None Selected" })),
            react_1.default.createElement("div", { className: "half" },
                react_1.default.createElement(InfoRow_1.default, { label: "Total DR/CR Value", negativeValue: getTotals().dr < 0, value: getTotals().dr.toFixed(2) }))),
        react_1.default.createElement("div", { className: "attachments no-input" },
            react_1.default.createElement("span", { className: "subtitle" }, "Attachments"),
            react_1.default.createElement("ul", null, data.attachments.length <= 0 ?
                react_1.default.createElement("p", null, "There are no attachments")
                :
                    data.attachments.map(function (attachment) { return (react_1.default.createElement("li", { key: attachment.id },
                        react_1.default.createElement("a", { href: config_1.default.api_base + "/attachment/" + attachment.id, title: attachment.fileName }, attachment.fileName))); }))),
        react_1.default.createElement("div", { className: "checkboxes flex flex-row" },
            react_1.default.createElement("div", { className: "half" },
                data.status === QueriesStore_1.QueryStatus.ACTIVE &&
                    data.queryStage.stage === 3 &&
                    userStore.hasPermission(UserStore_1.Permissions.STAGE_3) ?
                    react_1.default.createElement(Radios_1.default, { altLabel: "Preventative Action Required?", name: "preventativeAction", value: data.priceQuery.preventativeAction || false, onChange: changeHandler, options: [
                            { value: true, label: "Yes" },
                            { value: false, label: "No" }
                        ] })
                    :
                        react_1.default.createElement(InfoRow_1.default, { label: "Preventative Action Required?", value: data.priceQuery.preventativeAction ? "Yes" : "No" }),
                data.priceQuery.preventativeAction &&
                    react_1.default.createElement("div", { className: "hidden-inputs" }, data.status === QueriesStore_1.QueryStatus.ACTIVE &&
                        data.queryStage.stage === 3 &&
                        userStore.hasPermission(UserStore_1.Permissions.STAGE_3) ?
                        react_1.default.createElement(TextInput_1.default, { type: "text", name: "preventativeActionComment", altLabel: "Preventative Action", defaultValue: data.priceQuery.preventativeActionComment || "", onKeyUp: keyHandler })
                        :
                            react_1.default.createElement(InfoRow_1.default, { label: "Preventative Action Comment", value: data.priceQuery.preventativeActionComment || "" })),
                data.status === QueriesStore_1.QueryStatus.ACTIVE &&
                    data.queryStage.stage === 3 &&
                    userStore.hasPermission(UserStore_1.Permissions.STAGE_3) ?
                    react_1.default.createElement(Radios_1.default, { altLabel: "Back Order Refresh Required?", name: "backOrder", value: data.priceQuery.backOrder || false, onChange: changeHandler, options: [
                            { value: true, label: "Yes" },
                            { value: false, label: "No" }
                        ] })
                    :
                        react_1.default.createElement(InfoRow_1.default, { label: "Back Order Refresh Required?", value: data.priceQuery.backOrder ? "Yes" : "No" }),
                data.priceQuery.backOrder &&
                    react_1.default.createElement("div", { className: "hidden-inputs" }, data.status === QueriesStore_1.QueryStatus.ACTIVE &&
                        data.queryStage.stage === 3 &&
                        userStore.hasPermission(UserStore_1.Permissions.STAGE_3) ?
                        react_1.default.createElement(TextInput_1.default, { type: "text", name: "backOrderComment", altLabel: "Back Order Comment", defaultValue: data.priceQuery.backOrderComment || "", onKeyUp: keyHandler })
                        :
                            react_1.default.createElement(InfoRow_1.default, { label: "Back Order Comment", value: data.priceQuery.backOrderComment || "" })),
                data.queryStage.stage === 3 &&
                    userStore.hasPermission(UserStore_1.Permissions.STAGE_3) ?
                    react_1.default.createElement(Radios_1.default, { altLabel: "Customer / Sales Informed of Correct Pricing?", name: "correctPricing", value: data.priceQuery.correctPricing || false, onChange: changeHandler, options: [
                            { value: true, label: "Yes" },
                            { value: false, label: "No" }
                        ] })
                    :
                        react_1.default.createElement(InfoRow_1.default, { label: "Customer / Sales Informed of Correct Pricing?", value: data.priceQuery.correctPricing ? "Yes" : "No" }),
                data.priceQuery.correctPricing &&
                    react_1.default.createElement("div", { className: "hidden-inputs" }, data.status === QueriesStore_1.QueryStatus.ACTIVE &&
                        data.queryStage.stage === 3 &&
                        userStore.hasPermission(UserStore_1.Permissions.STAGE_3) ?
                        react_1.default.createElement(TextInput_1.default, { type: "text", name: "correctPricingComment", altLabel: "Correct Pricing Comment", defaultValue: data.priceQuery.correctPricingComment || "", onKeyUp: keyHandler })
                        :
                            react_1.default.createElement(InfoRow_1.default, { label: "Correct Pricing Comment", value: data.priceQuery.correctPricingComment || "" })),
                data.status === QueriesStore_1.QueryStatus.ACTIVE &&
                    data.queryStage.stage === 3 &&
                    userStore.levelPricePermission(data.priceQuery.approvalLevel) ?
                    checkAuthExists() ? null :
                        react_1.default.createElement("div", { className: "approve flex flex-row" },
                            react_1.default.createElement("span", null,
                                "Level ",
                                data.priceQuery.approvalLevel),
                            react_1.default.createElement(Button_1.default, { type: "button", onClick: approveHandler, title: "Approve" }, "Approve"),
                            react_1.default.createElement(Button_1.default, { type: "button", onClick: rejectHandler, title: "Reject" }, "Reject"))
                    : null),
            react_1.default.createElement("div", { className: "half" },
                react_1.default.createElement(AuthTable_1.default, { data: data.queryAuthorisations })))));
};
exports.default = PriceQueryStage3;
